import { useGuestEventHotelRoomBlocksQuery } from './components/Accommodations/Accommodations.graphql.generated';
import { useIsStaysRedesignActive } from './components/Honeymoon/useIsStaysRedesignActive';
import type { GuestPageContainerBySlugQuery } from './Custom.graphql.generated';

type Args = Readonly<{
  eventId: string | undefined;
  pageContainerData: GuestPageContainerBySlugQuery | undefined;
}>;

// SSR prefetch for hotel-room-blocks when a TravelMapComponent is present on a
// honeymoon-redesign event (PRNT-4234). Two-pass: pageContainerData is undefined on
// first pass; populated on the next pass after useFetchCustomPageData resolves.
// Cache key matches useAccommodationsData (widget-mount): { eventId } only.
export const useFetchAccommodationsSsrData = (args: Args) => {
  const { eventId, pageContainerData } = args;
  const isStaysRedesignActive = useIsStaysRedesignActive();

  const hasTravelMapComponent = pageContainerData?.pageContainerBySlug?.components?.some(component => component.__typename === 'TravelMapComponent');

  const skip = !isStaysRedesignActive || !eventId || !hasTravelMapComponent;

  useGuestEventHotelRoomBlocksQuery({
    variables: { eventId: eventId ?? '' },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    ssr: !skip,
    errorPolicy: 'all',
    skip,
  });
};
